import { DataSource } from './DataSource';
import { CmsBanner } from '../../components/cms/CmsBanner';
import { BannerSize } from '../../api/models/Shared.types';
import { Recipes } from '../utility/ImageRecipeUtil';
import { Backend } from '../../api/Backend';
import { ICustomCmsBanner } from '../../api/models/AndromeTV.types';

export class BannerDataSource extends DataSource {
  private banners: ICustomCmsBanner[];
  private pageProperties: string[];
  constructor(backend: Backend, banners: ICustomCmsBanner[], pageProperties: string[]) {
    super(backend);
    this.banners = banners;
    this.pageProperties = pageProperties;
  }

  override componentDescription() {
    return {
      focusable: true,
      type: CmsBanner,
      data: this,
    };
  }

  override load(): Promise<BannerDataSource> {
    return new Promise(resolve => {
      resolve(this);
    });
  }

  override isEmpty() {
    return false;
  }

  heightForWidth(width: number): number {
    if (this.banners.length > 0) {
      const banner = this.banners[0];
      switch (banner?.size) {
        case BannerSize.ASPECT_RATIO_7_2:
          return Math.floor((width / 7) * 2);
        case BannerSize.ASPECT_RATIO_7_3:
          return Math.floor((width / 7) * 3);
      }
    }
    return Math.floor(width / 7);
  }

  get recipe(): string {
    if (this.banners.length > 0) {
      const banner = this.banners[0];
      switch (banner?.size) {
        case BannerSize.ASPECT_RATIO_7_2:
          return Recipes.Banner.Medium;
        case BannerSize.ASPECT_RATIO_7_3:
          return Recipes.Banner.Large;
      }
    }
    return Recipes.Banner.Small;
  }
}
